import { Calendar } from "primereact/calendar";
import React, { useContext, useEffect, useRef, useState } from "react";
import { Toast } from "primereact/toast";
import { useForm } from "../../../../Hooks/useForm";
import { InputNumber } from "primereact/inputnumber";
import { Button } from "primereact/button";
import { classNames } from "primereact/utils";
import { toastShow } from "../../../../Services/ToastService";
import { setDateTimeSQL, setDateTimeSQLH } from "../../../../Services/FechasService";
import AgGrid from "../../../../Components/Tables/AgGrid/AgGrid";
import { TabPanel, TabView } from "primereact/tabview";
import { AuthContext } from "../../../../Context/AuthContext/AuthContext";
import { EditarCalendarioMensual, getCalendarioSemanalxMes, getFechasCierreInventario, getReferencias, insertFechasCierreInventario, updateFechasCierreInventario } from "../../../../../API/CalendarioOperativo/CalendarioOperativoRequest"; 
import Loader from "../../../../Components/Loader/Loader";

const CalendarioMensualCRUD = ({ editMes, onHide, actualizarScreen, CSM }) => {
  const toast = useRef(null);

  const { userAuth } = useContext(AuthContext);

  const [semanas, setSemanas] = useState([]);
  const [loading, setLoading] = useState(false);
  const [tab, setTab] = useState(0);
  const [fechasCierre, setFechasCierre] = useState([]);
  const [referencias, setReferencias] = useState([]);

  const initialValues = { 
    ...editMes,
    InicioMes: editMes.InicioMes ? new Date(editMes.InicioMes) : null,
    FinMes: editMes.FinMes ? new Date(editMes.FinMes) : null
  }
  
  const { values, setValues, handleInputChange, handleChange, setNumber, error, setError } = useForm(initialValues);


  const getInfo = async () => {
    setLoading(true);
    const semanasPorMes = await getCalendarioSemanalxMes(editMes?.IdMes);
    const FechasCierresTempo = await getFechasCierreInventario(editMes?.IdMes);
    setFechasCierre(FechasCierresTempo)
    const ref = await getReferencias();
    setReferencias(ref);
    setSemanas(semanasPorMes);
    handleChange(semanasPorMes.length, 'NoSemanas')
    setLoading(false);
  };

  const verificarCampos = () => {
    let error = {};
    let formIsValid = true;
    if (!values.InicioMes) {
      formIsValid = false;
      error["InicioMes"] = true;
    }
    if (!values.FinMes) {
      formIsValid = false;
      error["FinMes"] = true;
    }
    if (!values.TasaCambio) {
      formIsValid = false;
      error["TasaCambio"] = true;
    }
    if (!values.PorcentajeAlgodon) {
      formIsValid = false;
      error["PorcentajeAlgodon"] = true;
    }
    if (!values.PorcentajeSintetico) {
      formIsValid = false;
      error["PorcentajeSintetico"] = true;
    }
    setError(error);
    if (!formIsValid) {
      toastShow(
        toast,
        "error",
        "Error",
        "Favor de llenar los campos requeridos"
      );
    }
    return formIsValid;
  };

  const guardar = async () => {
    if (verificarCampos()) {

      const semanasValidas = semanas.filter((semana) => {
        const inicioSemana = new Date(semana?.InicioSemana);
        const finSemana = new Date(semana?.FinSemana);
        const inicioMes = new Date(values?.InicioMes);
        const finMes = new Date(values?.FinMes);
    
        return inicioSemana >= inicioMes && finSemana <= finMes;
    });

    const datos = {
      ...values,
      IdMes: editMes.IdMes,
      IdAnio: editMes.IdAnio,
      InicioMes: setDateTimeSQL(values.InicioMes),
      FinMes: setDateTimeSQL(values.FinMes),
      IdUserEdit: userAuth?.IdUser,
      PorcentajeAlgodon: values?.PorcentajeAlgodon,
      PorcentajeSintetico: values?.PorcentajeSintetico,
    };

    const datosSemanas = semanas.map((semana) =>({
      ...semana[0],
      IdSemana: semana?.IdSemana || -1,
      IdMes: semana.IdMes,
      NoSemana: semana.NoSemana,
      CuentaSemana: semana?.CuentaSemana,
      InicioSemana: semana?.InicioSemana,
      FinSemana: semana?.FinSemana,
      IdUserEdit: userAuth?.IdUser
    }))

    // GUARDAR CIERRES DE INVENTARIO
    fechasCierre.forEach(async s => {
      if(s.nuevo){
        let t = {
          ...s,
          FechaInicio: setDateTimeSQL(s.FechaInicio),
          FechaFin: setDateTimeSQLH(s.FechaFin)
        }
        insertFechasCierreInventario(t);
      }else{
        let t = {
          ...s,
          FechaInicio: setDateTimeSQL(s.FechaInicio),
          FechaFin: setDateTimeSQLH(s.FechaFin)
        }
        updateFechasCierreInventario(t);
      }
    })

    const respuesta = await EditarCalendarioMensual(datos, datosSemanas);
    if (respuesta[0]?.ESTADO === 1) {
      setLoading(true);
      toastShow(toast, "success", "Datos Agregados", respuesta[0]?.MENSAJE);
      setTimeout(() => {
        onHide();
      }, 1300);
      getInfo();
      actualizarScreen();
    } else {
      toastShow(toast, "error", "Error", respuesta[0]?.MENSAJE);
    }
    
    // if (semanasValidas.length !== semanas.length) {
    //     toastShow(
    //         toast,
    //         "error",
    //         "Error al guardar",
    //         "Algunas semanas seleccionadas no están dentro del mes Operativo."
    //     );
    // }
    // else{
      
    //   const datos = {
    //     ...values,
    //     IdMes: editMes.IdMes,
    //     IdAnio: editMes.IdAnio,
    //     InicioMes: setDateTimeSQL(values.InicioMes),
    //     FinMes: setDateTimeSQL(values.FinMes),
    //     IdUserEdit: userAuth?.IdUser
    //   };

    //   const datosSemanas = semanas.map((semana) =>({
    //     ...semana[0],
    //     IdSemana: semana?.IdSemana || -1,
    //     IdMes: semana.IdMes,
    //     NoSemana: semana.NoSemana,
    //     CuentaSemana: semana?.CuentaSemana,
    //     InicioSemana: semana?.InicioSemana,
    //     FinSemana: semana?.FinSemana,
    //     IdUserEdit: userAuth?.IdUser
    //   }))

    //   // GUARDAR CIERRES DE INVENTARIO
    //   fechasCierre.forEach(async s => {
    //     if(s.nuevo){
    //       let t = {
    //         ...s,
    //         FechaInicio: setDateTimeSQL(s.FechaInicio),
    //         FechaFin: setDateTimeSQLH(s.FechaFin)
    //       }
    //       insertFechasCierreInventario(t);
    //     }else{
    //       let t = {
    //         ...s,
    //         FechaInicio: setDateTimeSQL(s.FechaInicio),
    //         FechaFin: setDateTimeSQLH(s.FechaFin)
    //       }
    //       updateFechasCierreInventario(t);
    //     }
    //   })

    //   const respuesta = await EditarCalendarioMensual(datos, datosSemanas);
    //   if (respuesta[0]?.ESTADO === 1) {
    //     setLoading(true);
    //     toastShow(toast, "success", "Datos Agregados", respuesta[0]?.MENSAJE);
    //     setTimeout(() => {
    //       onHide();
    //     }, 1300);
    //     getInfo();
    //     actualizarScreen();
    //   } else {
    //     toastShow(toast, "error", "Error", respuesta[0]?.MENSAJE);
    //   }
    // }
      setLoading(false);
    }
  };

  const addSemana = () => {
    let week = [...semanas];
    let ultimaFecha = week.length > 0 ? week[week.length - 1].FinSemana : null;
    let ultimaCuenta = week.length > 0 ? week[week.length - 1].NoSemana : 0;
  
    const nuevoInicioSemana = week.length > 0
      ? new Date(new Date(ultimaFecha).getTime() + 24 * 60 * 60 * 1000)
      : new Date(values.InicioMes);
  
    const nuevoFinSemana = new Date(nuevoInicioSemana.getTime() + 6 * 24 * 60 * 60 * 1000);
  
    // if (nuevoInicioSemana > new Date(values.FinMes) || nuevoFinSemana > new Date(values.FinMes)) {
    //   toastShow(
    //     toast,
    //     "error",
    //     "Error",
    //     "No se puede agregar una semana fuera del mes seleccionado"
    //   );
    //   return;
    // }
    if (nuevoInicioSemana < new Date(values.InicioMes) || nuevoFinSemana < new Date(values.InicioMes)) {
      toastShow(
        toast,
        "error",
        "Error",
        "No se puede agregar una semana fuera del mes seleccionado"
      );
      return;
    }
  
    const t = {
      IdMes: editMes.IdMes,
      CuentaSemana: week.length + 1,
      NoSemana: ultimaCuenta + 1,
      InicioSemana: setDateTimeSQL(nuevoInicioSemana),
      FinSemana: setDateTimeSQL(nuevoFinSemana),
    };
  
    week.push(t);
    setSemanas(week);
    handleChange(week.length, "NoSemanas");
  };


  const addFechaCierre = () => {
    let cierres = [...fechasCierre];
    cierres.push({
      IdCierre: (fechasCierre.length + 1) * -1,
      IdEstado: 5,
      StatusName: 'Activo',
      IdMes: editMes.IdMes,
      FechaFin: values.FinMes,
      IdReferencia: null,
      Referencia: null,
      nuevo: true
    })
    setFechasCierre(cierres);
  }

  const columns = [
    {
      header: "No",
      handerEn: "NoWeek",
      field: "NoSemana",
      className: "Xsmall",
    },
    {
      header: "Cuenta",
      handerEn: "WeekCount",
      field: "CuentaSemana",
      className: "Xsmall",
    },
    {
      header: "IdMes",
      handerEn: "",
      field: "IdMes",
      className: "",
      hidden: false,
    },
    {
      header: "Mes",
      handerEn: "Month",
      field: "MesEsLargo",
      className: "Xsmall",
      hidden: false,
    },

    {
      header: "Inicio Semana",
      handerEn: "Start Week",
      field: "InicioSemana",
      className: "",
      Format: "Date",
      flex: 1,
      editable: true,
    },
    {
      header: "Fin Semana",
      handerEn: "End Week",
      field: "FinSemana",
      className: "",
      Format: "Date",
      editable: true,
      flex: 1,
    },
  ];

  const tableSemanas = {
    Data: semanas,
    // loading: loading,
    Columns: columns,
  };

  const tableCieres = {
    Data: fechasCierre,
    loading: loading,
    Columns: [
      {
        header: "IdCierre",
        headerEn: "",
        field: "IdCierre",
        className: "XXsmall",
        hidden: userAuth.IdRol === 1,
      },
      {
        header: "IdReferencia",
        headerEn: "",
        field: "IdReferencia",
        className: "XXsmall",
        hidden: userAuth.IdRol === 1,
      },
      {
        header: "Inventario",
        headerEn: "Inventory",
        field: "Referencia",
        className: "",
        editable: true,
        Format: "AutoComplete",
        items: referencias,
        label: "Referencia",
        value: "IdReferencia",
        flex: 1,
      },
      {
        header: "Estado",
        headerEn: "Status",
        field: "IdStatus",
        className: "Xsmall",
        Format: "Estado",
        filter: false,
        body: (rowData) => ({
          ID: rowData.StatusName,
          Estado: rowData.StatusName,
        }),
      },
      {
        header: "Fecha Inicio",
        headerEn: "",
        field: "FechaInicio",
        className: "",
        Format: "Date",
        editable: true,
        width: 130,
        onChange: (e) => {
          const { data } = e;
          const t = {
            ...data,
            FechaInicio: setDateTimeSQL(e.newValue),
            nuevo: false,
          };
          if (
            new Date(t.FechaInicio) < new Date(values.InicioMes) ||
            new Date(t.FechaInicio) >
              new Date(new Date(values.FinMes).getTime() + 1000)
          ) {
            toastShow(
              toast,
              "error",
              "Error",
              "No se puede agregar una semana fuera del mes seleccionado"
            );
            return;
          }
          let tem = [...fechasCierre];
          tem[fechasCierre.findIndex((f) => f.IdCierre === data.IdCierre)] = t;
          setFechasCierre(tem);
        },
      },
      {
        header: "Fecha Cierre",
        headerEn: "",
        field: "FechaFin",
        className: "",
        Format: "Date",
        editable: true,
        width: 130,
        onChange: (e) => {
          const { data } = e;
          const t = {
            ...data,
            FechaFin: setDateTimeSQL(e.newValue),
            nuevo: false,
          };
          if (
            new Date(t.FechaFin) < new Date(values.InicioMes) ||
            new Date(t.FechaFin) >
              new Date(new Date(values.FinMes).getTime() + 1000)
          ) {
            toastShow(
              toast,
              "error",
              "Error",
              "No se puede agregar una semana fuera del mes seleccionado"
            );
            return;
          }
          let tem = [...fechasCierre];
          tem[fechasCierre.findIndex((f) => f.IdCierre === data.IdCierre)] =
            t;
          setFechasCierre(tem);
        },
      },
    ],
  };

  useEffect(() => {
    if (editMes) {
      getInfo();
    }
  }, [editMes]);

  useEffect(() => {
    if(values?.PorcentajeAlgodon){
      let ValorSintetico = 100 - values?.PorcentajeAlgodon
      setValues({
        ...values,
        PorcentajeSintetico: ValorSintetico,
      })
    }else{
      setValues({
        ...values,
        PorcentajeSintetico: null,
      })
    }
  }, [values?.PorcentajeAlgodon]);

  return (
    <div id="Dialog">
      <Loader loading={loading} querySelector={"#Dialog"}></Loader>
      <div
        className="d-flex gap wrap p-2 flex-between"
        style={{ justifyContent: "space-between", alignItems: "center" }}
      >
        <Toast ref={toast} />
        <div style={{width: '100%'}} className="d-flex">
          <div style={{width: '25%'}}>
            <h3 style={{ textTransform: "capitalize" }}>
              {editMes.MesEsLargo} {editMes.Anio}
            </h3>
            <div>No Semanas: {values.NoSemanas}</div>
          </div>
          
          <div style={{width: '75%'}} className="d-flex gap-2">
            <div className="p-float-label">
              <Calendar
                id="InicioMes"
                value={values.InicioMes}
                onChange={(e) => handleInputChange(e, "InicioMes")}
                style={{ height: 45 }} 
                showIcon
                dateFormat="dd-mm-yy"
                className={classNames({ "p-invalid": error["InicioMes"] })}
              />
              <label htmlFor="FechaInicio">Fecha Inicio</label>
            </div>

            <div className="p-float-label">
              <Calendar
                id="FinMes"
                value={values.FinMes}
                onChange={(e) => handleInputChange(e, "FinMes")}
                showIcon
                style={{ height: 45 }} 
                dateFormat="dd-mm-yy"
                className={classNames({ "p-invalid": error["FinMes"] })}
              />
              <label htmlFor="FechaFin">Fecha Fin</label>
            </div>

            <div className="p-float-label">
              <InputNumber
                id="TasaCambio"
                value={values.TasaCambio}
                onChange={(e) => handleInputChange(e, "TasaCambio")}
                mode="decimal"
                minFractionDigits={4}
                className={classNames({ "p-invalid": error["TasaCambio"] })}
                maxFractionDigits={4}
              />
              <label htmlFor="TasaCambio">Tasa de Cambio</label>
              {/* <span className="p-error p-invalid">{error["TasaCambio"]}</span> */}
            </div>
            
          </div>
        </div>

        <div style={{width: '100%'}} className="d-flex">
          <div style={{width: '25%'}}>
          </div>
          
          <div style={{width: '75%', marginTop: -18}} className="d-flex gap-2">
            <div className="p-float-label">
              <InputNumber
                id="PorcentajeAlgodon"
                value={values.PorcentajeAlgodon}
                onChange={(e) => handleInputChange(e, "PorcentajeAlgodon")}
                mode="decimal"
                minFractionDigits={2}
                maxFractionDigits={2}
                className={classNames({ "p-invalid": error["PorcentajeAlgodon"] })}
                suffix=" %"
              />
              <label htmlFor="PorcentajeAlgodon">Porcentaje Algodon</label>
            </div>
            <div className="p-float-label">
              <InputNumber
                id="PorcentajeSintetico"
                value={values.PorcentajeSintetico}
                onChange={(e) => handleInputChange(e, "PorcentajeSintetico")}
                mode="decimal"
                className={classNames({ "p-invalid": error["PorcentajeSintetico"] })}
                minFractionDigits={2}
                maxFractionDigits={2}
                suffix=" %"
                disabled
              />
              <label htmlFor="PorcentajeSintetico">Porcentaje Sintetico</label>
            </div>
          </div>
        </div>


      </div>
      <TabView activeIndex={tab} onTabChange={(e) => setTab(e.index)}>
        <TabPanel header="Semanas" leftIcon="pi pi-calendar">
          <div style={{ height: "50vh" }}>
            <div className="p-2 d-flex">
              <div>
                <Button
                  icon="pi pi-plus"
                  onClick={addSemana}
                  className="mx-2"
                />
                <Button
                  icon="pi pi-refresh"
                  onClick={() => getInfo()}
                  loading={loading}
                />
              </div>
            </div>
            <div style={{ height: "90%" }}>
              <AgGrid table={tableSemanas} />
            </div>
          </div>
        </TabPanel>

        <TabPanel header="Cierre" leftIcon="pi pi-calendar">

          <div style={{ height: "50vh" }}>
            <div className="p-2 d-flex">
                <div>
                  <Button
                    icon="pi pi-plus"
                    onClick={addFechaCierre}
                    className="mx-2"
                  />
                  <Button
                    icon="pi pi-refresh"
                    onClick={() => getInfo()}
                    loading={loading}
                  />
                </div>
            </div>

            <div style={{ height: "90%" }}>
              <AgGrid table={tableCieres} />
            </div>
          </div>



        </TabPanel>
      </TabView>
      <div className="d-flex flex-end gap mt-3">
        <Button onClick={onHide}>Cancelar</Button>
        <Button severity="success" onClick={guardar}>
          Guardar
        </Button>
      </div>
    </div>
  );
};

export default CalendarioMensualCRUD;


// <div className="my-3">
{/* <h3 style={{ textTransform: "capitalize" }}>
  {editMes.MesEsLargo} {editMes.Anio}
</h3>
<div>No Semanas: {values.NoSemanas}</div> */}
// </div>
// <div className="d-flex gap ">
// <div className="p-field p-float-label col-4">
//   <Calendar
//     id="InicioMes"
//     value={values.InicioMes}
//     onChange={(e) => handleInputChange(e, "InicioMes")}
//     showIcon
//     dateFormat="dd-mm-yy"
//     className={classNames({ "p-invalid": error["InicioMes"] })}
//   />
//   <label htmlFor="FechaInicio">Fecha Inicio</label>
//   {/* <span className="p-error p-invalid">{error["InicioMes"]}</span> */}
// </div>

// <div className="p-field p-float-label col-4">
//   <Calendar
//     id="FinMes"
//     value={values.FinMes}
//     onChange={(e) => handleInputChange(e, "FinMes")}
//     showIcon
//     dateFormat="dd-mm-yy"
//     className={classNames({ "p-invalid": error["FinMes"] })}
//   />
//   <label htmlFor="FechaFin">Fecha Fin</label>
//   {/* <span className="p-error p-invalid">{error["FinMes"]}</span> */}
// </div>

// <div className="p-field p-float-label col-4 mt-1">
//   <InputNumber
//     id="TasaCambio"
//     value={values.TasaCambio}
//     onChange={(e) => handleInputChange(e, "TasaCambio")}
//     mode="decimal"
//     minFractionDigits={4}
//     className={classNames({ "p-invalid": error["TasaCambio"] })}
//     maxFractionDigits={4}
//   />
//   <label htmlFor="TasaCambio">Tasa de Cambio</label>
//   {/* <span className="p-error p-invalid">{error["TasaCambio"]}</span> */}
// </div>
// </div>